<template>
	<core-page>
		<common-alerts id="dashboard-alerts" :alerts="alerts" />
		<core-loading v-if="isLoading" />
		<div v-if="!hasSiteError" class="omapi-dash omapi-card__flex">
			<common-welcomebox v-if="!connected" :card-type="connected ? 'dismiss' : 'permanent'" :learn-more="true">
				Instantly grow your email list, get more leads and increase sales with the #1 most powerful conversion
				optimization toolkit in the world.
				<template #afterButtons>
					<core-button
						:href="$urls.docs('getting-started-optinmonster-wordpress-checklist', 'WelcomeBox')"
						class="omapi-create-campaign__link-more"
						target="_blank"
						rel="noopener noreferrer"
						:link-style="true"
						:arrow="true"
					>
						Read the Getting Started Guide
					</core-button>
				</template>
			</common-welcomebox>
			<dashboard-growth-upsell-box v-else-if="showGrowUpsell" />
			<dashboard-pro-upsell-box v-else-if="showProUpsell" />
			<common-welcome-back-box v-else-if="showWelcomeBack" />
			<dashboard-stats-widget />
			<div class="omapi-dash__cards-wrapper omapi-dash__cards-wrapper__left">
				<dashboard-template-select-widget />
			</div>
			<div class="omapi-dash__cards-wrapper omapi-dash__cards-wrapper__right">
				<dashboard-top-campaigns-widget />
				<dashboard-resources-widget />
			</div>
		</div>
		<dashboard-resources-widget v-else />
	</core-page>
</template>

<script>
import { bulkWatchHandler } from '@/utils';
import { mapState, mapGetters } from 'vuex';

export default {
	data() {
		return {
			canShowWelcomeBack: true,
		};
	},
	computed: {
		...mapGetters(['upgradeGrowth', 'topTier']),
		...mapState(['alerts']),
		...mapState('dashboard', ['dismissedWelcomeBack', 'dismissedProUpsell', 'dismissedGrowthUpsell']),
		...mapGetters(['connected', 'hasSiteError']),
		isLoading() {
			return this.$store.getters.isLoading('plugins');
		},
		showGrowUpsell() {
			return !this.topTier && 2 < this.visits && this.upgradeGrowth && !this.dismissedGrowthUpsell;
		},
		showProUpsell() {
			return !this.topTier && !this.upgradeGrowth && 2 < this.visits && !this.dismissedProUpsell;
		},
		showWelcomeBack() {
			return this.canShowWelcomeBack && !this.dismissedWelcomeBack;
		},
		visits() {
			return this.$get('$store.state.visits.' + (this.$route.fullPath || this.$route.path), 1);
		},
	},
	watch: bulkWatchHandler(['dismissedProUpsell', 'dismissedGrowthUpsell'], 'disableShowWelcomeBack'),
	beforeCreate() {
		this.$store.dispatch('dashboard/fetch');
	},
	methods: {
		disableShowWelcomeBack(dismissed) {
			if (dismissed) {
				this.canShowWelcomeBack = false;
			}
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/variables';
@import '../assets/scss/pages/dashboard';
</style>
